import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';
import { app as firebaseApp, firebaseConfig } from './firebaseConfig';

const requiredFirebaseConfig = {
  apiKey: firebaseConfig.apiKey,
  authDomain: firebaseConfig.authDomain,
  projectId: firebaseConfig.projectId,
  storageBucket: firebaseConfig.storageBucket,
  messagingSenderId: firebaseConfig.messagingSenderId,
  appId: firebaseConfig.appId,
};

/**
 * Returns true if all required Firebase config values are defined.
 */
export const isFirebaseConfigured = Object.values(requiredFirebaseConfig).every(Boolean);

export { firebaseApp };
export const auth = isFirebaseConfigured ? getAuth(firebaseApp) : null;
export const db = isFirebaseConfigured ? getFirestore(firebaseApp) : null;
export const functions = isFirebaseConfigured
  ? getFunctions(firebaseApp, process.env.REACT_APP_FUNCTIONS_REGION || 'us-central1')
  : null;
export const storage = isFirebaseConfigured ? getStorage(firebaseApp) : null;
